/**
 * StatusBadge (Phase 2, §7.5) — colour-coded German label for a connection's
 * lifecycle status, following the P1 badge pattern (see `DedupBadge`).
 */
import { CONNECTION_STATUS } from '../../../lib/labels.ts';
import type { ConnectionStatus } from '../../../lib/types.ts';

// Solid pastel pills per DESIGN.md §3.11.
const STYLE: Record<ConnectionStatus, string> = {
  active: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300',
  pending_auth: 'bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300',
  expired: 'bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300',
  error: 'bg-rose-100 text-rose-800 dark:bg-rose-950 dark:text-rose-300',
  revoked: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
};

export function StatusBadge({ status }: { status: ConnectionStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${STYLE[status]}`}
    >
      {CONNECTION_STATUS[status]}
    </span>
  );
}
